/**
 * Static config of subdomains/paths active on each VPS.
 *
 * Caddy routes by hostname/path convention (no runtime DB lookup), so this
 * list reflects what the routing rules actually serve on each host. When a
 * new project deploys (e.g. a future POS subdomain), add an entry here and
 * the platform-crm UI will surface it to operators registering domains.
 */

export interface ActiveSubdomain {
  /** Subdomain prefix shown in DNS instructions, e.g. "www", "staff", or "" for apex */
  host: string;
  /** Human-readable service name shown in the UI */
  service: string;
  /** Path prefix served on the apex/www host (when host is "" or "www") */
  pathPrefix?: string;
}

export const ACTIVE_SUBDOMAINS_TENANT: readonly ActiveSubdomain[] = [
  { host: "", service: "Landing" },
  { host: "www", service: "Tenant CRM", pathPrefix: "/crm" },
  { host: "staff", service: "Staff Management" },
];

export const ACTIVE_SUBDOMAINS_SUPPLIER: readonly ActiveSubdomain[] = [
  { host: "www", service: "Supplier CRM", pathPrefix: "/crm" },
];
